import { render, staticRenderFns } from "./v-form-call.vue?vue&type=template&id=0f507e36&"
import script from "./v-form-call.vue?vue&type=script&lang=js&"
export * from "./v-form-call.vue?vue&type=script&lang=js&"
import style0 from "./v-form-call.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports